import React from "react";

function About() {
  return (
    <section className="content-section">
      <div className="glass-card">
        <h1>About Me</h1>
        <p>
          Ich interessiere mich für Programmierung, Webentwicklung, cleane UIs
          und technische Designs mit Charakter.
        </p>
        <p>
          Besonders spannend finde ich React, TypeScript, Component-Architektur
          und Frontends, die nicht langweilig aussehen.
        </p>
      </div>
    </section>
  );
}

export default About;
